import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            name: yup.string().required(__(`form.name.error`))
        })
    )
}

export default validators
